@if (Match) {
  <!-- P6:1613. The card is a click target for pointers; the "Explore role" button is the one keyboard/AT control (no nested role=link). -->
  <div class="cx-card cx-rc" (click)="Explore()">
    <div class="cx-rch">
      <div>
        <span class="cx-sec" [class]="View.Tone">{{ Match.jobFamily }}</span>
        <h3>{{ Match.title }}</h3>
      </div>
      <ra-cx-ring [Percent]="View.Percent" [Size]="66" [Label]="View.PercentLabel" />
    </div>
    @if (View.Salary || View.Education) {
      <!-- P6:1614: Salary and Education only (see the component comment for the third P6 tile) -->
      <div class="cx-stats">
        @if (View.Salary) {
          <div class="cx-stat">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v18M16.5 7.5C15.6 6.4 14 6 12 6c-2.4 0-4 1-4 2.7 0 4 8.5 1.8 8.5 6 0 1.8-1.8 3-4.5 3-2.1 0-3.8-.6-4.8-1.8"/></svg>
            <div class="k">Salary</div>
            <div class="v">{{ View.Salary }}</div>
          </div>
        }
        @if (View.Education) {
          <div class="cx-stat">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 9l10-5 10 5-10 5zM6 11.5V16c0 1.2 2.7 3 6 3s6-1.8 6-3v-4.5"/></svg>
            <div class="k">Education</div>
            <div class="v">{{ View.Education }}</div>
          </div>
        }
      </div>
    }
    @if (View.Chips.length > 0) {
      <div class="cx-need">
        <div class="k">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01"/></svg>
          Skills needed for this role
        </div>
        <div class="cx-chips">
          @for (c of View.Chips; track c.Name) {
            <span class="cx-chip" [class.held]="c.Held">
              @if (c.Held) {
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>
                <span class="cx-sr">You have this: </span>
              }{{ c.Name }}
            </span>
          }
          @if (View.More > 0) { <span class="cx-more">+{{ View.More }} more</span> }
        </div>
      </div>
    }
    <button class="cx-link" type="button" [attr.aria-label]="'Explore ' + Match.title">
      Explore role
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
    </button>
  </div>
}
